import React from 'react';
import { useTranslation } from 'react-i18next';
import type { RosterViewMode } from '../types/Rostering';
import styles from './ViewModeToggle.module.css';

export type ViewModeToggleProps = {
  value: RosterViewMode;
  onChange: (mode: RosterViewMode) => void;
  className?: string;
};

export const ViewModeToggle: React.FC<ViewModeToggleProps> = ({
  value,
  onChange,
  className,
}) => {
  const { t } = useTranslation('rostering');

  return (
    <div className={[styles.toggle, className].filter(Boolean).join(' ')} role="group" aria-label={t('viewModeLabel')}>
      <button
        type="button"
        className={`${styles.option} ${value === 'week' ? styles.optionActive : ''}`}
        onClick={() => onChange('week')}
      >
        {t('viewWeek')}
      </button>
      <button
        type="button"
        className={`${styles.option} ${value === 'month' ? styles.optionActive : ''}`}
        onClick={() => onChange('month')}
      >
        {t('viewMonth')}
      </button>
    </div>
  );
};
